/* NILO Analytics V2 — storefront observation only.
   Requires consent through Shopify Customer Privacy API. No form values or personal identifiers. */
(function(){'use strict';
 const ENDPOINT=(window.NILO_ANALYTICS_ENDPOINT||'https://REPLACE-WITH-WORKER-URL/api/events').trim();
 if(!/^https:\/\//.test(ENDPOINT)||ENDPOINT.includes('REPLACE-WITH'))return;
 const P='nilo_a2_', V=P+'visitor', S=P+'session', ATTR=P+'attr', L=P+'session_time';
 const uid=()=>crypto.randomUUID().replaceAll('-','');
 const read=(store,key)=>{try{return store.getItem(key)}catch(_){return null}};
 const write=(store,key,val)=>{try{store.setItem(key,val)}catch(_){}};
 const consent=()=>{
  const p=window.Shopify?.customerPrivacy;
  if(!p||typeof p.analyticsProcessingAllowed!=='function')return false;
  try{return p.analyticsProcessingAllowed()===true}catch(_){return false}
 };
 const path=()=>location.pathname.slice(0,170);
 const product=()=>{let m=location.pathname.match(/\/(?:[a-z]{2}\/)?products\/([^/]+)/);return m?m[1]:''};
 const collection=()=>{let m=location.pathname.match(/\/(?:[a-z]{2}\/)?collections\/([^/]+)/);return m?m[1]:''};
 const device=()=>/iPhone|iPad/.test(navigator.userAgent)?'iOS':/Android/.test(navigator.userAgent)?'Android':'web';
 /* NILO_TRACKER_V204 */
 const diagnostic={version:'2.2.0',requests:0,accepted:0,lastHttp:null,serverError:''};
 const q=[];let active=false,started=Date.now(),sendTimer=null,scrollTimer=null,cardObserver=null,lastAttempt=0,lastCardTap='',prevTap={target:'',at:0},historyReady=false;
 let visitorId='',sessionId='',attr={};const impressions=new Set(),seenScroll=new Set();
 function externalReferrer(){
  try{
   if(!document.referrer)return {host:'',path:''};
   const u=new URL(document.referrer);
   if(!/^https?:$/.test(u.protocol)||u.hostname===location.hostname)return {host:'',path:''};
   // Querystrings, fragments and credentials are intentionally discarded.
   return {host:u.hostname.toLowerCase().slice(0,125),path:u.pathname.slice(0,160)};
  }catch(_){return {host:'',path:''}}
 }
 function inferSource(host,params){
  if(params.has('fbclid'))return 'meta';
  if(params.has('ttclid'))return 'tiktok';
  if(/(^|\.)(instagram\.com|facebook\.com|fb\.com|fb\.me|l\.facebook\.com)$/.test(host))return 'meta';
  if(/(^|\.)tiktok\.com$/.test(host))return 'tiktok';
  if(/(^|\.)(google\.[a-z.]+|bing\.com)$/.test(host))return 'search';
  return host?'referral':'direct';
 }
 function initIdentity(){
  let v=read(localStorage,V);const old=!!v;
  if(!v){v=uid();write(localStorage,V,v)}visitorId=v;
  let session=read(sessionStorage,S);
  if(!session){session=uid();write(sessionStorage,S,session)}sessionId=session;
  const p=new URLSearchParams(location.search);
  const ref=externalReferrer();
  const now={source:p.get('utm_source')||'',medium:p.get('utm_medium')||'',campaign:p.get('utm_campaign')||'',adset_id:p.get('adset_id')||'',ad_id:p.get('ad_id')||'',creative_id:p.get('utm_content')||'',referrer_host:ref.host,referrer_path:ref.path,landing_path:location.pathname.slice(0,170)};
  if(!now.source)now.source=inferSource(ref.host,p);
  // Persist the first entry point. Internal navigation must not erase ad attribution.
  const existing=read(sessionStorage,ATTR);
  if(!existing){write(sessionStorage,ATTR,JSON.stringify(now))}
  else if(p.has('utm_source')||p.has('utm_campaign')){
   write(sessionStorage,ATTR,JSON.stringify(now));
  }
  try{attr=JSON.parse(read(sessionStorage,ATTR)||'{}')}catch(_){attr=now}
  return old;
 }
 function props(src){const out={};for(const key of ['target','error_code','image_index','trigger','is_returning','selection_type','component','page_type','section','failure_stage']){
  const v=src?.[key];if(typeof v==='string')out[key]=v.replace(/[^\p{L}\p{N}_-]/gu,'').slice(0,55);else if(typeof v==='boolean'||typeof v==='number')out[key]=v;
 }return out;}
 function track(event,detail={}){if(!active||!consent())return;
  q.push({id:uid(),visitor_id:visitorId,session_id:sessionId,ts:new Date().toISOString(),event,path:path(),device:device(),source:attr.source||'',medium:attr.medium||'',campaign:attr.campaign||'',adset_id:attr.adset_id||'',ad_id:attr.ad_id||'',creative_id:attr.creative_id||'',referrer_host:attr.referrer_host||'',referrer_path:attr.referrer_path||'',landing_path:attr.landing_path||'',product:detail.product||product(),collection:detail.collection||collection(),variant:detail.variant||'',position:Number(detail.position)||null,scroll:Number(detail.scroll)||null,duration_ms:Number(detail.duration_ms)||null,price_cents:Number(detail.price_cents)||null,properties:props(detail)});
  if(q.length>=22)flush();else if(!sendTimer)sendTimer=setTimeout(flush,1900);
 }
 function flush(){
  if(sendTimer){clearTimeout(sendTimer);sendTimer=null}
  if(!active||!consent()){q.length=0;return}
  if(!q.length)return;
  const events=q.splice(0,35),body=JSON.stringify({events});
  diagnostic.requests++;
  fetch(ENDPOINT,{method:'POST',headers:{'content-type':'application/json'},body,mode:'cors',keepalive:true})
    .then(async r=>{
      diagnostic.lastHttp=r.status;
      try{const data=await r.json();diagnostic.accepted+=Number(data.accepted)||0;diagnostic.serverError=data.error||''}catch(_){}
      if(!r.ok)console.warn('[Nilo Analytics] HTTP',r.status,diagnostic.serverError)
    }).catch(e=>{diagnostic.lastHttp='network_error';console.warn('[Nilo Analytics] reseau',e?.message||e)});
 }
 function card(el){return el?.closest?.('.nilo-product-card,[data-nilo-product-handle]')}
 function handle(c){return c?.dataset?.niloProductHandle||c?.querySelector?.('a[href*="/products/"]')?.pathname?.split('/products/')[1]?.split('/')[0]||''}
 function observeCards(){if(!cardObserver||!active)return;
  document.querySelectorAll('.nilo-product-card').forEach(el=>{if(el.dataset.niloA2Observe)return;el.dataset.niloA2Observe='1';cardObserver.observe(el)});
 }
 function onScroll(){const d=document.documentElement,range=d.scrollHeight-innerHeight;if(range<10)return;
  const pct=Math.max(0,Math.min(100,Math.round(scrollY/range*100)));
  const ev=location.pathname==='/'?'home_scroll':collection()?'collection_scroll':null;
  for(const mark of [25,50,75,90,100])if(ev&&pct>=mark&&!seenScroll.has(mark)){seenScroll.add(mark);track(ev,{scroll:mark})}
  observeCards();
 }
 function cartAttempt(trigger,el){const now=Date.now();if(now-lastAttempt<500)return;lastAttempt=now;
  track('add_to_cart_click',{trigger,product:handle(card(el))||product()});
 }
 /* NILO_EVENT_FIX_V205 — Non-PII Nilo theme events. */
 function favoriteState(handle){
  // Only compare product handles. Never transmit or log wishlist storage contents.
  try{const list=JSON.parse(localStorage.getItem('nilo_wishlist_v1')||'[]');
    return Array.isArray(list)&&list.some(x=>x&&x.handle===handle);
  }catch(_){return null}
 }
 function followWishlist(button){
  const h=(button?.dataset?.niloWishlistHandle||'').slice(0,150);
  if(!h)return;
  const before=favoriteState(h),beforePressed=button.getAttribute('aria-pressed');
  setTimeout(()=>{
    const after=favoriteState(h),afterPressed=button.getAttribute('aria-pressed');
    if(before!==null&&after!==null&&before!==after)track(after?'wishlist_add':'wishlist_remove',{product:h,trigger:'wishlist_toggle'});
    else if(beforePressed!==afterPressed&&(afterPressed==='true'||afterPressed==='false'))
      track(afterPressed==='true'?'wishlist_add':'wishlist_remove',{product:h,trigger:'wishlist_toggle'});
  },80);
 }
 function onClick(e){
  const el=e.target instanceof Element?e.target:null;if(!el)return;
  const option=el.closest('[data-nilo-option-group] [data-nilo-option-value]');
  const group=option?.closest('[data-nilo-option-group]');
  const legend=(group?.querySelector('legend')?.textContent||'').toLowerCase();
  if(group){
   if(group.hasAttribute('data-nilo-color-group')||/couleur|colou?r|لون/i.test(legend))track('color_select');
   else if(/taille|size|pointure|مقاس|قياس/i.test(legend))track('size_select');
   else track('variant_view');
  }else if(el.closest('[data-nilo-qa-swatch],[data-nilo-color-value]'))track('color_select');
  else if(el.closest('[data-nilo-size-group],[data-nilo-size-value]'))track('size_select');
  else if(el.closest('[data-nilo-gallery-thumb],.nilo-product-gallery__thumb'))track('image_swipe');
  else if(el.closest('[data-nilo-wishlist-toggle],.nilo-product-card__heart'))track('wishlist_click');
  const heart=el.closest('[data-nilo-wishlist-toggle]');
  if(heart)followWishlist(heart);
  const btn=el.closest('button,input[type="submit"]'),a=el.closest('a'),c=card(el);
  if(btn&&btn.matches('[data-nilo-quick-add],.nilo-product-card__open'))track('quick_add_open',{product:handle(c),trigger:'quick_add'});
  const isAdd=!!(btn&&btn.matches('[data-nilo-quick-add-submit],[name="add"],.add_to_cart_button,.nilo-add-button,button[type="submit"][form="NiloProductForm"]'));
  if(isAdd)cartAttempt('button',el);
  else if(btn&&/^(ajouter au panier|add to cart|ajouter|أضف إلى السلة|أضف للسلة|زيد للسلة)/i.test((btn.textContent||'').trim()))cartAttempt('button',el);
  if(btn&&btn.matches('.nilo-add-button')){
   const sel=btn.closest('form')?.querySelector('[data-nilo-variant-select]');
   if(sel&&!sel.value)track('add_to_cart_blocked',{failure_stage:'missing_variant'});
  }
  if(btn&&btn.matches('[data-nilo-native-cod-open],[data-nilo-cod-inline-scroll]')){
   track('buy_now_click',{trigger:btn.closest('.nilo-product-sticky')?'sticky':btn.closest('[data-nilo-product-page]')?'product_page':'cart'});
   requestAnimationFrame(()=>{
    const drawer=document.querySelector('[data-nilo-native-cod-drawer]');
    if(drawer&&!drawer.hidden&&!drawer.hasAttribute('data-nilo-inline-cod'))track('cod_form_view',{trigger:'cod_open'});
   });
  }
  if(btn&&btn.closest('[data-nilo-native-cod-close]')){
    const dr=btn.closest('[data-nilo-native-cod-drawer]');
    if(dr&&!dr.hidden)track('cod_form_close',{trigger:'close_button'});
  }
  if(a&&c&&a.href?.includes('/products/'))track('product_click',{product:handle(c)});
  if(a&&a.closest('[data-nilo-home-category]'))track('category_click',{target:'popular_category'});
  else if(a&&/\/collections\//.test(a.pathname))track('category_click',{target:'collection_link'});
  if(a&&/banner|hero|panorama/i.test(a.className))track('banner_click',{target:'banner'});
  const target=btn?(btn.matches('[data-nilo-native-cod-open],[data-nilo-cod-inline-scroll]')?'cod_open':isAdd?'add_to_cart':btn.matches('[data-nilo-quick-add]')?'quick_add':'button'):
   a?(a.closest('[data-nilo-home-category]')?'category':c?'product':'link'):null;
  if(target){track('tap_target',{target});if(prevTap.target===target&&Date.now()-prevTap.at<550)track('rage_tap',{target});prevTap={target,at:Date.now()}}
 }
 function onSubmit(e){const form=e.target;
  if(!(form instanceof HTMLFormElement))return;
  if(form.matches('[data-nilo-native-cod-form]'))track('cod_submit_attempt',{trigger:'cod_form'});
  else if(/\/cart\/add(?:\.js)?\b/.test(form.action))cartAttempt('form_submit',form);
 }
 function onChange(e){
  const el=e.target;if(!(el instanceof HTMLElement))return;
  if(el.matches('[data-nilo-qa-option]')){
   const label=(el.closest('label')?.textContent||'').toLowerCase();
   if(/couleur|colou?r|لون/i.test(label))track('color_select');
   else if(/taille|size|pointure|مقاس|قياس/i.test(label))track('size_select');
   else track('variant_view');
  }else if(el.matches('[name*="size" i],[name*="taille" i]'))track('size_select');
  else if(el.matches('[name*="color" i],[name*="couleur" i]'))track('color_select');
 }
 function onAjax(ok,status,origin){track(ok?'add_to_cart_success':'add_to_cart_error',{error_code:ok?'':String(status||'network'),trigger:origin});}
 function wrapNetwork(){if(window.__niloAnalyticsV2Wrapped)return;window.__niloAnalyticsV2Wrapped=true;
  const origFetch=window.fetch;if(typeof origFetch==='function')window.fetch=async function(input,options){
   const url=typeof input==='string'?input:input?.url||'';
   const method=String(options?.method||input?.method||'GET').toUpperCase();
   const cart=/\/(?:[a-z]{2}\/)?cart\/add(?:\.js)?(?:\?|$)/.test(url);
   const codOrder=method==='POST'&&/\/apps\/nilo-cod\/order(?:\?|$)/.test(url);
   if(codOrder)track('cod_submit',{trigger:'cod_network'});
   try{
    const r=await origFetch.apply(this,arguments);
    if(cart)onAjax(r.ok,r.status,'fetch');
    if(codOrder){
     if(!r.ok)track('cod_order_error',{trigger:'cod_network',error_code:String(r.status)});
     else if(typeof r.clone==='function')r.clone().json().then(data=>{
      // Only observe the boolean result, never customer/order content.
      if(data?.ok===false)track('cod_order_error',{trigger:'cod_network',error_code:'rejected'});
     }).catch(()=>{});
    }
    return r;
   }catch(e){
    if(cart)onAjax(false,'network','fetch');
    if(codOrder)track('cod_order_error',{trigger:'cod_network',error_code:'network'});
    throw e;
   }
  };
  const open=XMLHttpRequest.prototype.open,send=XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open=function(method,url){this.__niloA2Cart=typeof url==='string'&&/\/(?:[a-z]{2}\/)?cart\/add(?:\.js)?(?:\?|$)/.test(url);return open.apply(this,arguments)};
  XMLHttpRequest.prototype.send=function(){if(this.__niloA2Cart)this.addEventListener('loadend',()=>onAjax(this.status>=200&&this.status<300,this.status,'xhr'));return send.apply(this,arguments)};
 }
 function setup(){if(active||!consent())return;active=true;const returning=initIdentity();track('session_start',{is_returning:returning});
  const name=path()==='/'?'home_view':collection()?'collection_view':product()?'view_item':/^\/cart(?:\/|$)/.test(path())?'cart_view':'app_open';track(name);
  document.addEventListener('click',onClick,{capture:true,passive:true});document.addEventListener('submit',onSubmit,{capture:true,passive:true});document.addEventListener('change',onChange,{capture:true,passive:true});
  document.addEventListener('focusin',e=>{if(e.target?.matches?.('input[type="search"]'))track('search_click')},{passive:true});
  // Nilo COD emits this only after a confirmed successful order; no order details are read.
  window.addEventListener('nilo:order-created',()=>track('cod_order_success',{trigger:'cod_confirmation'}));
  window.addEventListener('scroll',()=>{if(!scrollTimer)scrollTimer=setTimeout(()=>{scrollTimer=null;onScroll()},250)},{passive:true});
  document.addEventListener('visibilitychange',()=>{if(consent())track(document.hidden?'app_background':'app_foreground')});
  window.addEventListener('pagehide',()=>{if(product())track('product_view_duration',{duration_ms:Date.now()-started});track('session_end',{duration_ms:Date.now()-started});flush()});
  if('IntersectionObserver' in window){cardObserver=new IntersectionObserver(entries=>entries.forEach(e=>{
    if(!e.isIntersecting)return;cardObserver.unobserve(e.target);const h=handle(e.target);if(!h)return;
    const key=path()+':'+h+':'+(e.target.dataset.niloPrice||'');if(impressions.has(key))return;impressions.add(key);
    const kids=e.target.parentElement?.children||[],position=Array.prototype.indexOf.call(kids,e.target)+1;
    track('product_impression',{product:h,position,price_cents:Number(e.target.dataset.niloPrice)||null});
  }),{threshold:0.5});observeCards();if('MutationObserver' in window){let next;new MutationObserver(()=>{clearTimeout(next);next=setTimeout(observeCards,220)}).observe(document.body,{childList:true,subtree:true})}}
  wrapNetwork();
  // V5.13.74: inline COD is not a popup. Count a view only when its form
  // actually enters the viewport. Never treat page load as an open event.
  const inlineCod=document.querySelector('[data-nilo-inline-cod]');
  if(inlineCod && 'IntersectionObserver' in window){
    let inlineViewed=false;
    const codObserver=new IntersectionObserver(entries=>{
      if(inlineViewed) return;
      if(entries.some(entry=>entry.isIntersecting&&entry.intersectionRatio>=.3)){
        inlineViewed=true; codObserver.disconnect();
        track('cod_form_view',{trigger:'inline_visible'});
      }
    },{threshold:[.3]});
    codObserver.observe(inlineCod.querySelector('[data-nilo-native-cod-form]')||inlineCod);
  }
  // Presence approximation: refresh at most every 60 s when tab is visible and consented.
  const beat=setInterval(()=>{
   if(!active||!consent()){clearInterval(beat);return}
   if(!document.hidden)track('session_heartbeat',{trigger:'visible'});
  },60000);
 }
 window.NiloAnalytics={track,status:()=>({version:diagnostic.version,privacyApi:!!window.Shopify?.customerPrivacy,
  analyticsAllowed:consent(),active,queued:q.length,requests:diagnostic.requests,
  accepted:diagnostic.accepted,lastHttp:diagnostic.lastHttp,serverError:diagnostic.serverError})};
 document.addEventListener('visitorConsentCollected',()=>{
  if(consent())setup();else{active=false;q.length=0;if(sendTimer){clearTimeout(sendTimer);sendTimer=null}}
 },false);
 let privacyLoading=false;
 function boot(){
  if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed){setup();return}
  if(privacyLoading||typeof window.Shopify?.loadFeatures!=='function')return;
  privacyLoading=true;
  try{window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],error=>{
    privacyLoading=false;
    if(error)console.warn('[Nilo Analytics] API Shopify non disponible');
    else setup();
  })}catch(e){privacyLoading=false;console.warn('[Nilo Analytics] Shopify',e?.message||e)}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
 let checks=0;const timer=setInterval(()=>{if(active||++checks>30)clearInterval(timer);else boot()},1000);
})();
